<template>
    <div>
        <div class="row text-center">
            <div class="col-lg-3 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">سرفصل</span>
                    </div>
                    <vs-select :data="mainAccounts" :mode="'create'"
                               :header="{multiple: false, label: 'title'}"
                               @onChange="onChange"></vs-select>
                </div>
            </div>
            <div class="col-lg-3 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">زیر سرفصل :</span>
                    </div>
                    <vs-select :data="cashs" :mode="'create'"
                               :header="{multiple: false, label: 'outSourceName'}"
                               @onChange="onChange2"></vs-select>
                </div>
            </div>
            <div class="col-lg-6 col-12 mt-2">
                <div class=" d-inline-block mx-3">
                    <div class="input-group mb-2">
                        <button type="button" class="d-inline-block btn btn-success" @click="onPrintClicked"><i
                                class="fa fa-print"></i></button>
                        <div class="input-group-prepend" @click="toggleStartDatePicker">
                            <div class="input-group-text"><span>از تاریخ :</span></div>
                        </div>
                        <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"
                                     ref="datePickerStart" style="flex: 1">
                            <slot>
                                <input v-model="startDatePersian" class="form-control date-input" readonly="true"
                                       @click="toggleStartDatePicker">
                                <button class="close reset-date" @click="resetStartDate">×</button>
                            </slot>
                        </date-picker>
                    </div>
                </div>
                <div class="d-inline-block">
                    <div class="input-group mb-2">
                        <div class="input-group-prepend" @click="toggleEndDatePicker">
                            <div class="input-group-text"><span>تا تاریخ :</span></div>
                        </div>
                        <date-picker type="date" :auto-submit="true" :disable="startDatePersian" format="jYYYY-jMM-jDD"
                                     @input="onEndDatePicked"
                                     ref="datePickerEnd" style="flex: 1;">
                            <slot>
                                <input v-model="endDatePersian" class="form-control date-input" readonly="true"
                                       @click="toggleEndDatePicker">
                                <button class="close reset-date" @click="resetEndDate">×</button>
                            </slot>
                        </date-picker>
                    </div>
                </div>
                <!--<div class="d-inline-block mx-3">-->
                <!--<button class="btn btn-primary" @click="getReport">ثبت</button>-->
                <!--</div>-->
            </div>
        </div>
        <hr/>

        <!--<div v-if="transactions.length < dataCount" class="col-lg-12 text-center mb-3" @click="getTransactions">-->
        <!--<button class="btn btn-success">نمایش اسناد بیشتر</button>-->
        <!--</div>-->

        <div class="row">
            <div v-if="transactions === undefined || transactions.length ==0" class="col-lg-12 text-center mt-5 mb-3">
                <h3 class="no-item-alert">گزارشی یافت نشد!</h3>
            </div>
            <div v-else class="table-responsive col-12" id="printMe">
                <h4 class="w-100 text-center">گزارش تزار
                    {{mainSel}} {{secSell}}
                </h4>
                <table class="table table-hover table-striped">
                    <thead>
                    <tr>
                        <th class="text-center text-nowrap" v-if="isDetail">تاریخ</th>
                        <th class="text-center text-nowrap">نام حساب</th>
                        <th class="text-center text-nowrap" v-if="isDetail">شماره سند</th>
                        <th class="text-center text-nowrap" v-if="isDetail">شرح سند</th>
                        <th class="text-center text-nowrap">بدهکار</th>
                        <th class="text-center text-nowrap">بستانکار</th>
                        <th class="text-center text-nowrap" v-if="!isDetail">مانده بدهکار</th>
                        <th class="text-center text-nowrap" v-if="!isDetail">مانده بستانکار</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in transactions">
                        <td class="text-center" v-if="isDetail">{{item.persianDate}}</td>
                        <td class="text-center" v-if="!isDetail">{{item.name}}</td>
                        <td class="text-center" v-if="isDetail">{{item.account}}</td>
                        <td class="text-center" v-if="isDetail">{{item.voucherNumber}}</td>
                        <td class="text-center" style="word-wrap: break-word;" v-if="isDetail">{{item.description}}</td>
                        <td class="text-center">{{item.debtor.toLocaleString()}}</td>
                        <td class="text-center">{{item.creditor.toLocaleString()}}</td>
                        <td class="text-center" v-if="!isDetail">{{item.remDeb.toLocaleString()}}</td>
                        <td class="text-center" v-if="!isDetail">{{item.remCrd.toLocaleString()}}</td>
                    </tr>
                    <tr>
                        <td class="text-center"><b>مجموع</b></td>
                        <td class="text-center" v-if="isDetail"></td>
                        <td class="text-center" v-if="isDetail"></td>
                        <td class="text-center" v-if="isDetail"></td>
                        <td class="text-center"><b>{{totalDebtor.toLocaleString() }}</b></td>
                        <td class="text-center"><b>{{totalCreditor.toLocaleString()}}</b></td>
                        <td class="text-center" v-if="!isDetail"><b>{{totalRemDeb.toLocaleString() }}</b></td>
                        <td class="text-center" v-if="!isDetail"><b>{{totalRemCrd.toLocaleString() }}</b></td>
                    </tr>

                    </tbody>
                </table>
            </div>
            <!--<div v-if="transactions !== undefined && transactions.length < dataCount" class="col-lg-12 text-center mb-3"-->
            <!--@click="getTransactions">-->
            <!--<button class="btn btn-success">نمایش تراکنش های بیشتر</button>-->
            <!--</div>-->
            <div class="col-lg-12">
                <div class="sk-circle" id="loading">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import Moment from "moment-jalali";
    import EventBus from "../../_framework/event-bus.js";
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect"
    import VueHtmlToPaper from 'vue-html-to-paper';


    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    export default {
        name: 'dbalance-report',
        components: {
            DatePicker,
            VsSelect,
        },
        data() {
            return {
                transactions: [],
                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,
                    // type: 1
                },
                queryParams2: {
                    pageSize: 10000,
                    pageIndex: 0,
                    parrentId: 1
                },
                dataCount: 0,

                listView: false,
                fromDate: "",
                fromDateJ: "",
                toDate: "",
                toDateJ: "",
                startDatePersian: "",
                endDatePersian: "",
                providers: [],


                totalDebtor: 0,
                totalCreditor: 0,
                totalRemDeb: 0,
                totalRemCrd: 0,
                totalRemain: 0,
                mainAccounts: [
                    {id: 0, title: "همه حسابها"},
                    {id: 1, title: "بانکها"},
                    {id: 2, title: "صندوق ها"},
                    {id: 3, title: "مشتری ها"},
                    {id: 5, title: "تامین کننده ها"},
                    {id: 6, title: "سرمایه(موجودی اولیه)"},
                    {id: 7, title: "درآمدها"},
                    {id: 8, title: "هزینه ها"},
                    // {id: 9, title: "تولید"},
                    {id: 10, title: "فروش"},
                    {id: 11, title: "خرید"},
                    {id: 12, title: "چک های دریافتی"},
                    {id: 13, title: "چک های پرداختی"},
                    {id: 20, title: "سایر سرفصلها"},
                    // {id: 14, title: "فروش اینترنتی"},
                ],
                cashs: [],
                selectedMain: 0,
                selectedCash: 0,
                keepData: false,
                showCash: false,
                isDetail: false,
                mainSel: "",
                secSell: "",

            }
        },
        mounted() {
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);
            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            this.getReport();
            // this.getProviders();
        },
        methods: {
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },

            getTransactions() {
                this.queryParams.pageIndex++;
                this.keepData = true;
                $("#loading").show();
                this.getReport();
            },
            onCardClicked(e, index) {
                /*this.overallAmount = 0;
                let id = this.vouchers[index].id;
                new BaseService('voucher', `/getproducts/${id}`).getList().then(response => {
                    this.voucher = response.data;
                    for (let item of this.voucher.products) {
                        this.overallAmount += item.unitVal;
                    }
                    $("#voucherData").modal("show");
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                })*/
            },
            getProviders() {
                new BaseService('outsource', '/getlist').getList(this.queryParams2).then(response => {
                    this.cashs = response.data.data;
                    // console.log(this.banks);
                    let allPro = {
                        id: 0,
                        outSourceName: "همه موارد"
                    };
                    // this.banks.push(allPro);
                }).catch(error => {
                    console.log(error)
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            toggleEndDatePicker() {
                this.$refs.datePickerEnd.togglePicker();
            },
            onStartDatePicked(val) {
                this.fromDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.startDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            onEndDatePicked(val) {
                this.toDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.endDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
                // this.queryParams.accountTitleId = this.selectedBank !== 0 ? this.selectedBank : this.selectedCash;

                this.queryParams.fromdate = this.fromDate;
                this.queryParams.toDate = this.toDate;
                this.queryParams.pageSize = 10000;
                this.queryParams.pageIndex = 0;
                // this.queryParams.type = 1;


                this.keepData = false;
                this.getReport();
            },
            resetStartDate() {
                this.fromDate = '';
                this.startDatePersian = '';
            },
            resetEndDate() {
                this.toDate = '';
                this.endDatePersian = '';
            },
            getReport() {
                if (!this.keepData) {
                    this.transactions = [];
                }
                this.fromDate = Moment(new Date()).format('YYYY-MM-DD');
                this.startDatePersian = Moment(this.fromDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                this.toDate = Moment(new Date()).format('YYYY-MM-DD');
                this.endDatePersian = Moment(this.fromDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');

                this.queryParams.fromdate = this.fromDate;
                this.queryParams.toDate = this.toDate;

                new BaseService('reports', '/GetBalanceReport').getList(this.queryParams).then(response => {
                    let a;
                    let actions = response.data.data;
                    this.dataCount = response.data.count;
                    this.totalDebtor = 0;
                    this.totalCreditor = 0;
                    this.totalRemDeb = 0;
                    this.totalRemCrd = 0;
                    this.transactions = [];
                    if (actions !== undefined || actions != null) {
                        let remains = 0;
                        for (let item of actions) {
                            let date = Moment(item.date, 'YYYY-MM-DD').format("jDD jMMMM jYYYY");
                            Vue.set(item, "persianDate", date);
                            item.remains = item.debtor - item.creditor + item.remain + remains;
                            remains = item.remains;
                            this.totalDebtor = this.totalDebtor + item.debtor;
                            this.totalCreditor = this.totalCreditor + item.creditor;
                            this.totalRemain = remains;
                            // console.log(item)
                            switch (item.outSourceType) {
                                case 1:
                                    this.calculateReminds(1, "بانکها", item);

                                    break;
                                case 2:
                                    this.calculateReminds(2, "صندوقها", item);

                                    break;
                                case 3:
                                    this.calculateReminds(3, "مشتریها", item);

                                    break;
                                case 5:
                                    this.calculateReminds(5, "تامین کننده ها", item);

                                    break;
                                case 6:
                                    this.calculateReminds(6, "سرمایه(موجودی اولیه)", item);

                                    break;
                                case 7:
                                    this.calculateReminds(7, "درآمدها", item);

                                    break;
                                case 8:
                                    this.calculateReminds(8, "هزینه ها", item);

                                    break;
                                // case 9:
                                //     this.calculateReminds(9, "تولیدها", item);
                                //
                                //     break;
                                case 11:
                                    this.calculateReminds(11, "خریدها", item);

                                    break;
                                case 10:
                                    this.calculateReminds(10, "فروش ها", item);

                                    break;
                                case 12:
                                    this.calculateReminds(12, "چکهای دریافتی", item);

                                    break;
                                case 13:
                                    this.calculateReminds(13, "چکهای پرداختی", item);
                                    break;

                            }
                        }


                    }
                    for (let itm of this.transactions) {
                        this.totalRemDeb += itm.remDeb;
                        this.totalRemCrd += itm.remCrd;
                    }
                    $("#loading").hide();
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },
            calculateReminds(outSourceId, name, item) {
                let find13 = false;
                let a;
                // console.log(outSourceId)
                for (let it of this.transactions) {
                    if (it.outSourceType == outSourceId) {
                        it.debtor += item.debtor;
                        it.creditor += item.creditor;
                        it.remains += item.remains;
                        find13 = true;
                        a = it.debtor - it.creditor;
                        if (a > 0) {
                            it.remDeb = a;
                            it.remCrd = 0;
                            // this.totalRemDeb += a;
                        } else if (a < 0) {
                            it.remCrd = -a;
                            it.remDeb = 0;
                            // this.totalRemCrd += -a;
                        } else {
                            it.remCrd = 0;
                            it.remDeb = 0;
                        }
                        break;
                    }
                }
                if (!find13) {
                    item.name = name;
                    a = item.debtor - item.creditor;
                    if (a > 0) {
                        item.remDeb = a;
                        item.remCrd = 0;
                        // this.totalRemDeb += a;
                    } else if (a < 0) {
                        item.remCrd = -a;
                        item.remDeb = 0;
                        // this.totalRemCrd += -a;
                    } else {
                        item.remCrd = 0;
                        item.remDeb = 0;
                    }
                    this.transactions.push(item);
                }
            },
            onChange: function (val) {
                console.log(val)
                if (val) {
                    this.mainSel = val.title;
                }
                if (val.id === 0) {
                    this.isDetail = false;
                    this.isDetail = false;
                    this.selectedMain = val.id;
                    this.keepData = false;
                    this.queryParams.outsourceType = this.selectedMain;
                    this.queryParams.pageIndex = 0;
                    this.getReport();
                    this.queryParams2.types = this.selectedMain;
                    this.getProviders();
                } else {
                    this.isDetail = false;
                    this.selectedMain = val.id;
                    this.keepData = false;
                    this.queryParams.outsourceType = this.selectedMain;
                    this.queryParams.pageIndex = 0;
                    // this.getReport();
                    this.queryParams2.types = this.selectedMain;
                    this.getProviders();
                    new BaseService('reports', '/GetBalanceReport').getList(this.queryParams).then(response => {
                        let actions = response.data.data;
                        let a;
                        this.dataCount = response.data.count;
                        this.totalDebtor = 0;
                        this.totalCreditor = 0;
                        this.totalRemain = 0;
                        this.totalRemCrd = 0;
                        this.totalRemDeb = 0;
                        this.transactions = [];
                        if (actions !== undefined || actions != null) {
                            let remains = 0;

                            for (let item of actions) {
                                let date = Moment(item.date, 'YYYY-MM-DD').format("jDD jMMMM jYYYY");
                                Vue.set(item, "persianDate", date);
                                item.remains = item.debtor - item.creditor + item.remain + remains;
                                remains = item.remains;
                                this.totalDebtor = this.totalDebtor + item.debtor;
                                this.totalCreditor = this.totalCreditor + item.creditor;
                                this.totalRemain = remains;

                                let find = false;
                                for (let it of this.transactions) {
                                    if (it.name === item.account) {
                                        it.debtor += item.debtor;
                                        it.creditor += item.creditor;
                                        it.remains += item.remains;
                                        find = true;
                                        a = it.debtor - it.creditor;
                                        if (a > 0) {
                                            it.remDeb = a;
                                            it.remCrd = 0;
                                        } else if (a < 0) {
                                            it.remCrd = -a;
                                            it.remDeb = 0;

                                        } else {
                                            it.remCrd = 0;
                                            it.remDeb = 0;
                                        }
                                        break;
                                    }
                                }
                                if (!find) {
                                    item.name = item.account;
                                    a = item.debtor - item.creditor;
                                    if (a > 0) {
                                        item.remDeb = a;
                                        item.remCrd = 0;
                                    } else if (a < 0) {
                                        item.remCrd = -a;
                                        item.remDeb = 0;
                                    } else {
                                        item.remCrd = 0;
                                        item.remDeb = 0;
                                    }
                                    this.transactions.push(item);
                                }
                            }
                            for (let item2 of this.transactions) {
                                this.totalRemDeb += item2.remDeb;
                                this.totalRemCrd += item2.remCrd;
                            }
                        }
                        $("#loading").hide();
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.message, this.$noty);
                    });
                }

            },
            onChange2(val) {
                console.log(val)
                if (val) {
                    this.secSell = val.outSourceName;
                }
                this.isDetail = true;
                this.queryParams.outsourceId = val.id;
                this.keepData = false;
                this.selectedCash = val.id;

                new BaseService('reports', '/GetBookReport').getList(this.queryParams).then(response => {
                    let actions = response.data.data;
                    this.dataCount = response.data.count;
                    this.totalDebtor = 0;
                    this.totalCreditor = 0;
                    this.totalRemain = 0;
                    this.transactions = [];
                    if (actions !== undefined || actions != null) {
                        let remains = 0;
                        for (let item of actions) {
                            let date = Moment(item.date, 'YYYY-MM-DD').format("jDD jMMMM jYYYY");
                            Vue.set(item, "persianDate", date);
                            item.remains = item.debtor - item.creditor + item.remain + remains;
                            remains = item.remains;
                            this.totalDebtor = this.totalDebtor + item.debtor;
                            this.totalCreditor = this.totalCreditor + item.creditor;
                            this.totalRemain = remains;
                            this.transactions.push(item);
                        }
                    }
                    $("#loading").hide();
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },


        }
    }
</script>